import React, {Fragment, useState} from 'react';
import './css/allprojects.css';
import {projectData} from '../../data/projectData';
import {Link} from 'react-router-dom';

const AllProjects = () => {
    const [data] = useState(projectData);

    return (
        <Fragment>
               <div className="Total_Project">
                   <h2>OUR PROJECTS</h2>
                    <div className="Project_container">
                
                    {data.map((d,i)=>(
                        <div key={i} className="card" data-aos="fade-up"  data-aos-duration="1000">
                            <div className="imgBx">
                                <img src={d.img} alt="Harshitha developers and constructions" width="100%" height="100%" />
                            </div>
                            <div className="Project_content">
                                <h2>{d.status} Project</h2>
                                <p> {d.title}</p>
                                <Link to={`/projects/${d.id}`} className='btn'>view Project</Link>
                            </div>
                        </div>
                    ))}

                    </div>
               </div>
        </Fragment>
    )
}

export default AllProjects;
